import styles from './UtilMenuItem.scss';

import { ReferencedEntry } from 'contentful';
import React from 'react';

import { ContentType, ExternalLink, InternalLink, Link, LinkSet, ModalLink, NavigationItem, Page, Product, is } from 'src/api/contentful/contentTypes.cloverdotcom';
import { IContentLinkProps } from 'src/components/ContentLink/ContentLink';

import { getContentType } from 'src/utils/CloverdotcomEntryUtil';
import { getField, isEntry } from 'src/utils/EntryUtil';
import { CartLink } from './CartLink/CartLink';
import { UtilLink } from './UtilLink/UtilLink';

export interface IUtilMenuItem extends IContentLinkProps {
  entry?: ReferencedEntry<NavigationItem>;
  hidden?: boolean;
  mobile?: boolean;
  children?: never;
}

export function getUrl(entry?: ReferencedEntry<Link>): string | undefined {
  switch (getContentType(entry)) {
    case ContentType.EXTERNAL_LINK:
      return getField(entry as ReferencedEntry<ExternalLink>, 'url');
    case ContentType.INTERNAL_LINK:
      return getField(getField(entry as ReferencedEntry<InternalLink>, 'page'), 'slug');
    case ContentType.MODAL_LINK:
      return getField(getField(entry as ReferencedEntry<ModalLink>, 'modal'), 'slug');
    case ContentType.BASIC_PAGE:
      return getField(entry as ReferencedEntry<Page>, 'slug');
    case ContentType.PRODUCT:
      return getUrl(getField(entry as ReferencedEntry<Product>, 'link'));
    default:
      return undefined;
  }
}

export const CART_URL = /(\/cart){1}(\/)?/;

export const isCartUrl = (url?: string): boolean => !!url && CART_URL.test(url);

export const UtilMenuItem: React.FC<IUtilMenuItem> = ({ entry, ...props }) => {
  if (!isEntry(entry) || is<LinkSet>(ContentType.LINK_SET, entry)) return null;

  const Component = isCartUrl(getUrl(entry)) ? CartLink : UtilLink;

  return (
    <li className={styles.item}>
      <Component entry={entry} className={styles.link} {...props} />
    </li>
  );
};
